import styles from './Copyright.module.scss'

const Copyright = () => (
	<div className={styles.copyright}>
		© {new Date().getFullYear()} SchoolsMobile. All rights reserved.
	</div>
)

export default Copyright
